import type { ResolutionTypeOption } from '@/types/case';

/** Default reporting method for new cases. */
export const DEFAULT_CASE_REPORTING_METHOD = 'ESP FOH Voice';

/** Available reporting method options for the case form dropdown. */
export const REPORTING_METHOD_OPTIONS = [
  { value: 'ESP FOH Voice', label: 'ESP - FOH Voice' },
  { value: 'ESP Chat', label: 'ESP - Chat' },
  { value: 'ESP AHR Voice', label: 'ESP - AHR Voice' },
];

/** Status codes that indicate a case is closed / resolved. */
const CLOSED_STATUS_CODES = new Set(['Complete', 'Resolved']);

export function isCaseClosed(status: string): boolean {
  return CLOSED_STATUS_CODES.has(status);
}

/** Build resolution type dropdown options from API response, with an empty default. */
export function buildResolutionTypeOptions(
  types: ResolutionTypeOption[]
): Array<{ value: string; label: string }> {
  return [
    { value: '', label: '—' },
    ...types.map(t => ({ value: t.id, label: t.name })),
  ];
}

/** Prepend "Contact ID: <id>" to a description unless it already contains the id. */
export function attachContactIdToDescription(
  description: string,
  contactId: string | null | undefined,
  contactIdLabel: string
): string {
  if (!contactId || description.includes(contactId)) return description;
  const marker = `${contactIdLabel}: ${contactId}`;
  return description ? `${marker}\n${description}` : marker;
}
